import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Add escape key listener
    document.addEventListener('keydown', this.handleEscape);
  }

  handleEscape = (event) => {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  close() {
    // Navigate to the registration page using Rails router
    window.location = this.getRegistrationPath();
  }

  getRegistrationPath() {
    // Get the signup path from a meta tag or return the default path
    return '/users/sign_up';
  }

  disconnect() {
    // Clean up event listeners
    document.removeEventListener('keydown', this.handleEscape);
  }
}